module.exports = __webpack_public_path__ + "static/media/asset13.31d14855.png";